import React from 'react';
import { StarIcon, TrendingDownIcon } from 'lucide-react';
export function SocialProof() {
  return <section className="py-16 bg-slate-900" data-id="element-135">
      <div className="max-w-4xl mx-auto px-4" data-id="element-136">
        <div className="bg-gradient-to-r from-blue-900/40 to-slate-800 rounded-2xl p-8 md:p-12 border border-blue-500/20 text-center shadow-2xl relative overflow-hidden" data-id="element-137">
          <div className="flex justify-center gap-1 mb-6" data-id="element-138">
            {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="w-6 h-6 text-yellow-400 fill-yellow-400" data-id="element-139" />)}
          </div>

          <div className="flex items-center justify-center gap-4 mb-6" data-id="element-140">
            <TrendingDownIcon className="w-12 h-12 text-green-400" data-id="element-141" />
            <h2 className="text-5xl md:text-6xl font-extrabold text-white" data-id="element-142">
              60%
            </h2>
          </div>

          <h3 className="text-2xl font-bold text-white mb-4" data-id="element-143">
            Reducción en la latencia del sueño
          </h3>

          <p className="text-lg md:text-xl text-slate-300 leading-relaxed max-w-2xl mx-auto italic" data-id="element-144">
            "En solo 7 días, los usuarios informan una reducción del 60% en el
            tiempo que tardan en dormirse y la desaparición del pánico nocturno
            al saber que tienen una herramienta real para recuperar el control."
          </p>
        </div>
      </div>
    </section>;
}